import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";

export class Success extends Component {
  continue = (e) => {
    e.preventDefault();
    // PROCESS FORM //
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    return (
      <MuiThemeProvider>
        <>
          <Dialog open fullWidth maxWidth="sm">
            <AppBar title="Success" />
            <h1>Placeholder</h1>
            <p>
              This will redirect to a dashboard to select portions of
              recommendations to print out as PDF - tips, resources, other
              relevant information, etc.
            </p>
          </Dialog>
        </>
      </MuiThemeProvider>
    );
  }
}

export default Success;
